module.exports = __webpack_public_path__ + "static/media/4560.c9f76af3.jpg";